import React from 'react';
import { Layout } from '../components/layout';
import { useConfiguration } from '../hooks/useConfiguration';
import { useTranslation } from 'react-i18next';
import { ContactForm } from '../elements/privacy/contactForm';
import { GeneralInfo } from '../elements/privacy/generalInfo';
import { Contact } from '../elements/privacy/contact';
import { Registration } from '../elements/privacy/registration';

export const Privacy = () => {
  const configuration = useConfiguration();

  const { t, i18n } = useTranslation();

  if (configuration === undefined) {
    return null;
  }

  const { copyright } = configuration;
  const footerLink = `/imprint/${i18n.language}`;
  return (
    <Layout copyright={copyright} footerLink={footerLink} footerLinkTitle={t('privacy.footer.imprintLink')}>
      <section className='profile'>
        <div className='content'>
          <div className='row'>
            <div className='col-9'>
              <h1 className='profile__title'>{t('privacy.title')}</h1>
            </div>
          </div>

          <div className='text'>
            <GeneralInfo region={configuration.region} />

            <ContactForm region={configuration.region} />

            <h3>{t('privacy.cookies.title')}</h3>
            <p>{t('privacy.cookies.text')}</p>

            <Registration region={configuration.region} />

            <h3>{t('privacy.rights.title')}</h3>
            <p>{t('privacy.rights.paragraph_1')}</p>
            <p>{t('privacy.rights.paragraph_2')}</p>

            <h3>{t('privacy.amendments.title')}</h3>
            <p>{t('privacy.amendments.text')}</p>

            <h3>{t('privacy.questions.title')}</h3>
            <p>{t('privacy.questions.text')}</p>

            <hr />

            <Contact region={configuration.region} />
          </div>
        </div>
        <div className='clear-footer clear-footer--light'></div>
      </section>
    </Layout>
  );
};
